export default __webpack_public_path__ + "static/media/Missed_Call.7c2a39c4.svg";